// extracted by mini-css-extract-plugin
export default {"cls1":"mentions_milestone_ping-cls1___ed21ad81222b1942496","cls2":"mentions_milestone_ping-cls2__c4cfa21e209ea1397d54 mentions_milestone_ping-cls1___ed21ad81222b1942496"};